<template>
    <section
        class="mb-4 overflow-hidden bg-white border border-gray-200 rounded-xl"
    >
        <div
            class="flex items-center justify-between gap-3 px-4 py-3 bg-white border-b border-gray-100"
            :class="collapsed && !$slots.preview ? 'border-b-0' : ''"
        >
            <div
                class="flex-1 min-w-0 text-sm font-semibold text-gray-900 [&_h1]:mb-0 [&_h1]:text-sm [&_h1]:font-semibold [&_h2]:mb-0 [&_h2]:text-sm [&_h2]:font-semibold [&_h3]:mb-0 [&_h3]:text-sm [&_h3]:font-semibold [&_h4]:mb-0 [&_h4]:text-sm [&_h4]:font-semibold [&_h5]:mb-0 [&_h5]:text-sm [&_h5]:font-semibold [&_h6]:mb-0 [&_h6]:text-sm [&_h6]:font-semibold"
            >
                <slot name="header"></slot>
            </div>

            <button
                type="button"
                class="inline-flex items-center justify-center flex-shrink-0 w-7 h-7 text-gray-500 transition-colors border border-gray-200 rounded-md hover:bg-gray-50 hover:text-gray-700 focus:outline-none focus:ring-1 focus:ring-gray-300"
                :aria-label="collapsed ? 'Expand section' : 'Collapse section'"
                :aria-expanded="(!collapsed).toString()"
                :title="collapsed ? 'Expand section' : 'Collapse section'"
                v-on:click="collapseExpand"
            >
                <ChevronDownIcon v-if="collapsed" class="w-4 h-4" />
                <MinusSmIcon v-if="!collapsed" class="w-4 h-4" />
            </button>
        </div>

        <div
            v-if="$slots.preview"
            class="px-4 py-3 overflow-hidden text-xs text-gray-500 bg-gray-50"
            :class="collapsed ? '' : hiddenClass"
        >
            <slot name="preview"></slot>
        </div>

        <div
            v-if="$slots.body && !collapsed"
            class="px-4 py-3 overflow-hidden text-xs text-gray-700"
            :class="!collapsed ? '' : hiddenClass"
        >
            <slot name="body"></slot>
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon, MinusSmIcon } from '@heroicons/vue/solid';

export default {
    components: { MinusSmIcon, ChevronDownIcon },
    props: {
        startCollapsed: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            collapsed: this.startCollapsed,
        };
    },
    methods: {
        collapseExpand() {
            this.collapsed = !this.collapsed;
        },
    },
    computed: {
        hiddenClass() {
            return 'max-h-0 focus-within:max-h-full';
        },
    },
};
</script>
